import { Component, EventEmitter, Output, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-check-box',
    templateUrl: './check-box.component.html',
    styleUrls: ['./check-box.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckBoxComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CheckBoxComponent implements ControlValueAccessor {
  _value: boolean;
  @Input() get value() {
    return this._value ?? false;
  }
  set value(val) {
    this._value = val;
  }

  @Input() label: string;

  @Output() valueChange = new EventEmitter<boolean>();

  constructor() { }

  onValueChanged() {
    this.valueChange.emit(this.value);
    this.onTouch(this.value);
    this.onChange(this.value);
  }

  onChange: any = () => { }

  onTouch: any = () => { }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
}
